import Call from '../../Call.v2';
import {objToQs} from '../../Utils';

const Report = {
    get(type, filters) {
        return Call(`propellerAds/report/${type}?${objToQs(filters)}`);
    },

    getGraph(type, filters) {
        return Call(`propellerAds/report/${type}/graph?${objToQs(filters)}`);
    },

    getSubid(type, filters) {
        return Call(`propellerAds/report/${type}/subid?${objToQs(filters)}`);
    },
};

export default Report;



// WEBPACK FOOTER //
// ./src/services/API/components/PropellerAds/Report.js